﻿/**
 * portal-link-group-link.repository
 * @namespace portal
 */

(function () {
	'use strict';

	/** add the repo */
	angular.module('nha.portal').service('portal-link-group-link.repository', portalLinkGroupLinkRepo);

	/** injection */
	portalLinkGroupLinkRepo.$inject = ['repositoryFactory', 'PortalRestangular'];

	/** implementation */
	function portalLinkGroupLinkRepo(repositoryFactory, portalRestangular) {
		/** create the repo */
		var repo = new repositoryFactory('PortalLinkGroupLink', portalRestangular);

		/** additional public methods */
		repo.getForGroup = getForGroup;
		repo.reorder = reorder;

		/** reorder the group links */
		function reorder(groups) {
			return this.put(groups, '/reorder');
		}

		/** get the group links */
		function getForGroup(groupID) {
			/** send request */
			return portalRestangular.all(this.endpoint + '/getforgroup/' + groupID).customGET().then(function(portalLinkGroupLinks) {
				/** return group links */
				return portalLinkGroupLinks;
			});
		}

		/** return the repo */
		return repo;
	}
})();